import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderTextField } from "../../../Components/Forms/renders";
import datumField from "../../../Components/Forms/datepast";
class LogboekFormWebsite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      inschrijving: false,
    };
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <Field
            name="naam"
            type="input"
            validate={required({ msg: "Dit item is verplicht" })}
            component={renderField}
            label="Naam van de faciliteit"
          />
          <Field
            name="beschrijving"
            type="input"
            validate={required({ msg: "Dit item is verplicht" })}
            component={renderTextField}
            label="Omschrijving van de faciliteit"
          />
          <Field name="startdatum" type="input" validate={required({ msg: "Dit item is verplicht" })} component={datumField} label="Startdatum" />
          <Field name="einddatum" type="input" validate={required({ msg: "Dit item is verplicht" })} component={datumField} label="Einddatum" />
          <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Wijzigen" />
        </div>
      </form>
    );
  }
}
LogboekFormWebsite = reduxForm({
  form: "forhorecaedit", // a unique identifier for this form
})(LogboekFormWebsite);

// You have to connect() to any reducers that you wish to connect to yourself
LogboekFormWebsite = connect(
    (state) => ({
      initialValues: state.horeca.item, // pull initial values from account reducer
    }) // bind account loading action creator
  )(LogboekFormWebsite);

export default LogboekFormWebsite;
